import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que saber cocinar?',
    a: 'No, las 50 recetas son ultra sencillas y rápidas.'
  }, {
    q: '¿Es caro?',
    a: 'No, son ingredientes que ya conoces, pero usados con estrategia renal.'
  }, {
    q: '¿Interfiere con mis medicinas?',
    a: 'Es 100% nutricional, por lo que apoya y no sustituye tu tratamiento médico.'
  }];
  return <section className="py-20 px-6 bg-cream" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <FadeIn data-id="element-44">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-forest" data-id="element-45">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-6" data-id="element-46">
            {faqs.map((faq, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-47">
                <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-48">
                  {faq.q}
                </h3>
                <p className="text-lg text-gray-600" data-id="element-49">{faq.a}</p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}